/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableTournamentUpdater
 */
export interface AvailableTournamentUpdater {
    /**
     * 
     * @type {string}
     * @memberof AvailableTournamentUpdater
     */
    updaterName: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableTournamentUpdater
     */
    type: string;
}

/**
 * Check if a given object implements the AvailableTournamentUpdater interface.
 */
export function instanceOfAvailableTournamentUpdater(value: object): value is AvailableTournamentUpdater {
    if (!('updaterName' in value) || value['updaterName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function AvailableTournamentUpdaterFromJSON(json: any): AvailableTournamentUpdater {
    return AvailableTournamentUpdaterFromJSONTyped(json, false);
}

export function AvailableTournamentUpdaterFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableTournamentUpdater {
    if (json == null) {
        return json;
    }
    return {
        
        'updaterName': json['updaterName'],
        'type': json['type'],
    };
}

export function AvailableTournamentUpdaterToJSON(value?: AvailableTournamentUpdater | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'updaterName': value['updaterName'],
        'type': value['type'],
    };
}

